import React, { useState, useRef } from 'react';
import { FaArrowLeft, FaCheck, FaTimes, FaUpload } from 'react-icons/fa';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import goodpic1 from '../../../../../../assets/Heygen/goodpicexampleone.png'
import goodpic2 from '../../../../../../assets/Heygen/goodpicexamplesec.png'
import goodpic3 from '../../../../../../assets/Heygen/goodpicexamplerhi.png'
import goodpic4 from '../../../../../../assets/Heygen/goodpicexamplefour.png'
import goodpic5 from '../../../../../../assets/Heygen/goodpicexamplefive.png'
import badpic1 from '../../../../../../assets/Heygen/badpicexampleone.png'
import badpic2 from '../../../../../../assets/Heygen/badpicexamplesec.png'
import badpic3 from '../../../../../../assets/Heygen/badpicexamplethir.png'
import badpic4 from '../../../../../../assets/Heygen/badpicexamplefour.png'
import badpic5 from '../../../../../../assets/Heygen/badpicexamplefive.png'
import { button_bg_color_for_New_Project } from '../../../../../../constants/colors';
import { Box, Checkbox, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { CreateAvatarByImage, GetPersonalAvatarData, UploadPersonalPhotoForHeygen } from '../../../../../../contexts/WorkspaceUtils';
import CommonToast from '../../../../../Common_Components/CommonToast';
import { useWorkspace } from '../../../../../../contexts/WorkspaceContext';
import { Spinner } from 'react-bootstrap';

const CustomAvatar = ({ onClose,setPersonalAvatar, setPersonalAvatarLoader}) => {
  const [currentStep, setCurrentStep] = useState('upload'); // 'upload', 'review', 'details', 'complete'
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imageuploadFile, setImageUploadFile] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    // gender: 'Unspecified',
    // ethnicity: 'Unspecified',
    termsAccepted: false
  });
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const fileInputRef = useRef(null);
  const [openToast, setOpenToast] = useState(false)
  const [content, setContent] = useState(null)
  const [iconType, setIconType] = useState(null)
  const [uploadImageLoader, setUploadImageLoader] = useState(false)
  const [avatarCreationLoader, setAvatarCreationLoader] = useState(false)
  const {uploadedImageData, setUploadedImageData,  isModalOpenForAvatarGenerationOption, setIsModalOpenForAvatarGenerationOption, setSelectedVideoGenerationPlatform} = useWorkspace()

  const onCloseToast = () =>{
    setOpenToast(false);
  }

  const goodImageExampleArray = [
    {img: goodpic1, name:"image1"},
    {img: goodpic2, name:"image2" },
    {img: goodpic3, name:"image3"},
    {img: goodpic4, name:"image4"},
    {img: goodpic5, name:"image5"},
  ]

    const badImageExampleArray = [
    {img: badpic1, name:"image1"},
    {img: badpic2, name:"image2" },
    {img: badpic3, name:"image3"},
    {img: badpic4, name:"image4"},
    {img: badpic5, name:"image5"},
  ]

  console.log("selectedFiles", selectedFiles)

  const handleFileChange = (e) => {
  // Take only the first file if multiple are selected
  const file = e.target.files[0]; 
  
  if (file) {
    const validTypes = ['image/jpeg', 'image/png', 'image/heic', 'image/webp'];
    const isValidType = validTypes.includes(file.type);
    const isValidSize = file.size <= 200 * 1024 * 1024; // 200MB
    
    if (isValidType && isValidSize) {
      setSelectedFiles([file]); // Store as array with single file
      setImageUploadFile(file);
    }
  }
};

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const uploadFile  = async () => {
    //Logic to upload Photo for Creating Heygen Photo Avatar
    // const formData = new FormData();
    // console.log("fileInputRef",fileInputRef)
    // const data = {
    //   "file" : selectedFiles
    // }
    const formDataForUpload = new FormData();
    formDataForUpload.append("file", imageuploadFile); 
    try{
      setUploadImageLoader(true)
      const response = await UploadPersonalPhotoForHeygen(formDataForUpload);
      const res = await response.json();
      console.log("response", res)
      
      if(res.status){
      console.log("res", res) 
      setOpenToast(true);
      setContent(res?.message);
      setIconType("success")
      setUploadedImageData(res?.data?.data)
      setCurrentStep("review")
      }else{
      setOpenToast(true);
      setContent(res?.message);
      setIconType("error")
      }
    }catch(error){
      console.error("error", error);
      setOpenToast(true);
      setContent(error.message);
      setIconType("error")
    }
    
    setUploadImageLoader(false)
  }

  const createAvatar = async () => {
    if(formData?.name === ""){
      setOpenToast(true);
      setContent("Please Enter Avatar Name")
      setIconType("error")
      return
    }
  const data = {
              image_key: uploadedImageData?.image_key,
              name: formData?.name
          } 
    try{
      setAvatarCreationLoader(true)
      const res =await CreateAvatarByImage(data)
      const responseData = await res.json()
      if(responseData.status){
        setCurrentStep('complete');
      }else{
      setOpenToast(true);
      setContent(responseData?.message)
      setIconType("error")
      }
    }catch(error){
      setOpenToast(true);
      setContent(error?.message)
      setIconType("error")
      console.error("error", error)
    }
      setAvatarCreationLoader(false)


  }

  const handleProceed =async () => {
    if (currentStep === 'upload') {
      uploadFile()
      // setCurrentStep('review');

    } else if (currentStep === 'review') {
      setCurrentStep('details');
    } else if (currentStep === 'details') {
      await createAvatar()
    }
  };

  const fetchPersonalAvatars = async () => {
    setPersonalAvatarLoader(true)
        try {
          const response = await GetPersonalAvatarData ();
          const res = await response.json()
          setPersonalAvatar(res?.data);
        } catch (error) {
          console.error("Error fetching avatars:", error);
        }
        setPersonalAvatarLoader(false)
      };

  const handleDoneButtonClick = () => {
    onClose();
    setIsModalOpenForAvatarGenerationOption(false)
    fetchPersonalAvatars();
  }

  const customTextFieldStyles = (isInvalid) => {
    return {
      "& .MuiInputLabel-root": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "0.5px",
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
        },
      },
      "& .MuiInputBase-input": {
        color: "#FFFFFF",
      },
      "& #outlined-basic-label": {
        color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&:hover fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&.Mui-focused fieldset": {
          borderColor: isInvalid
            ? "#F2B8B5 !important"
            : "rgba(255, 255, 255, 0.80) ",
        },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
        color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80) ",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isInvalid
          ? "#F2B8B5 !important"
          : "rgba(255, 255, 255, 0.80) ",
      },
    };
  };

  const renderUploadStep = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', height: '100%' }}>
      <div>
        <div style={{
          color: '#FFF',
          fontFamily: 'Inter',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: '600',
          lineHeight: '20px',
          marginBottom: '8px'
        }}>
          Upload photos of your avatar
        </div>
        <div style={{
          color: 'rgba(255, 255, 255, 0.80)',
          fontFamily: 'Inter',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: 'normal'
        }}>
          Upload photos to create multiple looks for your avatar
        </div>
      </div>

      <div style={{
        display: 'flex',
        width: '710px',
        padding: '20px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '24px',
        borderRadius: '12px',
        background: '#1A1E35'
      }}>
        <div style={{
          color: '#FFF',
          textAlign: 'center',
          fontFamily: 'Inter',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: 'normal'
        }}>
          Select files or drop to upload
        </div>
        <div style={{
          color: 'rgba(255, 255, 255, 0.60)',
          textAlign: 'center',
          fontFamily: 'Inter',
          fontSize: '12px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: 'normal'
        }}>
          JPEG, PNG, HEIC, WEBP, upto 200mb
        </div>
        <button 
          onClick={handleUploadClick}
          style={{
            display: 'flex',
            width: '220px',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '12px 24px',
            borderRadius: '8px',
            background: 'white',
            border: 'none',
            color: 'black',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            gap: '8px'
          }}
        >
          <CloudUploadOutlinedIcon />
          Browse files
        </button>
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: 'none' }}
          accept="image/jpeg, image/png, image/heic, image/webp"
        />
      </div>

      {selectedFiles?.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{
            color: '#FFF',
            fontFamily: 'Inter',
            fontSize: '14px',
            fontWeight: '500'
          }}>
            Selected files ({selectedFiles?.length})
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
            {selectedFiles?.map((file, index) => (
              <div key={index} style={{
                width: '100px',
                height: '100px',
                borderRadius: '8px',
                background: `url(${URL.createObjectURL(file)}) center/cover no-repeat`,
                border: '1px solid rgba(255, 255, 255, 0.2)'
              }} />
            ))}
          </div>
        </div>
      )}

      <div style={{
        width: '710px',
        height: '537px',
        flexShrink: '0',
        borderRadius: '16px',
        border: '1px solid rgba(255, 255, 255, 0.10)',
        background: '#1F233E',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px'
      }}>
        <div style={{
          color: '#FFF',
          fontFamily: 'Inter',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: '20px',
          letterSpacing: '0.1px'
        }}>
          Photo Requirements
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <FaCheck color="#4CAF50" />
            <div style={{
              color: '#FFF',
              fontFamily: 'Inter',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: '500',
              lineHeight: '20px',
              letterSpacing: '0.1px'
            }}>
              Good photos
            </div>
          </div>
          <div style={{
            color: 'rgba(255, 255, 255, 0.80)',
            fontFamily: 'Inter',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal',
            letterSpacing: '0.1px'
          }}>
            Recent photos of yourself (just you), showing a mix of close-ups and full-body shots, with different angles, expressions (smiling, neutral, serious), and a variety of outfits. Make sure they are High-resolution and reflect your current appearance.
          </div>
          <div style={{ display: 'flex', width: '640px', justifyContent: 'space-between', alignItems: 'center' }}>
            {goodImageExampleArray?.map((obj, i) => (
              <div key={`good-${i}`} style={{
                width: '93.838px',
                height: '124px',
                flexShrink: '0',
                aspectRatio: '93.84/124.00',
                borderRadius: '8px',
                background: '#2D3250'
              }} >
                <img width={"93.838px"} height={"124px"} src={obj?.img} alt={obj?.name} />
              </div>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <FaTimes color="#F44336" />
            <div style={{
              color: '#FFF',
              fontFamily: 'Inter',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: '500',
              lineHeight: '20px',
              letterSpacing: '0.1px'
            }}>
              Bad photos
            </div>
          </div>
          <div style={{
            color: 'rgba(255, 255, 255, 0.80)',
            fontFamily: 'Inter',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal',
            letterSpacing: '0.1px'
          }}>
            No group photos, hats, sunglasses, pets, heavy filters, low-resolution images, or screenshots. Avoid photos that are too old, overly edited, or don't represent how you currently look.
          </div>
          <div style={{ display: 'flex', width: '640px', justifyContent: 'space-between', alignItems: 'center' }}>
            {badImageExampleArray?.map((obj, i) => (
              <div key={`bad-${i}`} style={{
                width: '93.838px',
                height: '124px',
                flexShrink: '0',
                aspectRatio: '93.84/124.00',
                borderRadius: '8px',
                background: '#2D3250'
              }} >
                <img width={"93.838px"} height={"124px"} src={obj?.img} alt={obj?.name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  const renderReviewStep = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', height: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <button 
          onClick={() => setCurrentStep('upload')}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'white',
            cursor: 'pointer'
          }}
        >
          <FaArrowLeft />
        </button>
        <div style={{
          color: '#FFF',
          fontFamily: 'Inter',
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: '600',
          lineHeight: '20px'
        }}>
          Review your uploaded photos
        </div>
      </div>

      <div style={{
        color: 'rgba(255, 255, 255, 0.80)',
        fontFamily: 'Inter',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: 'normal',
        letterSpacing: '0.1px'
      }}>
        Approved photos have been marked and are ready for creating a look for your avatar. You can proceed with the selected ones or upload more
      </div>

      <div style={{ 
        display: 'flex', 
        flexWrap: 'wrap', 
        gap: '16px',
        justifyContent: 'space-between'
      }}>
        {selectedFiles.map((file, index) => (
          <div 
            key={index}
            style={{
              width: '166.486px',
              height: '220px',
              flexShrink: '0',
              aspectRatio: '166.49/220.00',
              borderRadius: '16px',
              background: `url(${URL.createObjectURL(file)}) center/cover no-repeat`,
              border: selectedAvatar === index ? 'none' : '1px solid rgba(255, 255, 255, 0.2)',
              cursor: 'pointer',
              position: 'relative'
            }}
            onClick={() => setSelectedAvatar(index)}
          >
            {selectedAvatar === index && (
              <div style={{
                position: 'absolute',
                top: '8px',
                left: '8px',
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                background: '#4F46E5',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border:"none"
              }}>
                {/* <FaCheck size={12} color="white" /> */}
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <g clip-path="url(#clip0_11266_63971)">
                    <circle cx="10" cy="10" r="10" fill="#9EFFCF"/>
                    <path d="M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z" fill="#23A565"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_11266_63971">
                      <rect width="20" height="20" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );

  const renderDetailsStep = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', height: '100%' }}>
      <div style={{
        color: '#FFF',
        fontFamily: 'Inter',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '20px'
      }}>
        Your avatar is ready!
      </div>
      <div style={{
        color: 'rgba(255, 255, 255, 0.80)',
        fontFamily: 'Inter',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: 'normal'
      }}>
        Add a few details to bring your avatar to life
      </div>

      {selectedAvatar !== null && (
        <div style={{
          width: '93.838px',
          height: '124px',
          flexShrink: '0',
          aspectRatio: '93.84/124.00',
          borderRadius: '8px',
          background: `url(${URL.createObjectURL(selectedFiles[selectedAvatar])}) center/cover no-repeat`
        }} />
      )}

      <Box
  sx={{
    display: 'flex',
    gap: 2,        // MUI spacing scale – equals 16px by default
    width: '100%',
    mb: 3,
  }}
>
  <TextField
    type="text"
    label="Name*"
    placeholder="What do you want to name your avatar?"
    value={formData?.name || ''}
     onChange={(e) => setFormData(prev => ({
        ...prev,
        name: e.target.value
    }))}
    variant="outlined"
    id="outlined-basic"
    sx={[
      customTextFieldStyles(false),
      {
        flex: 1,             // takes up equal share
        maxHeight: 56,
        fontSize: 14,
      },
    ]}
  />

  {/* <TextField
    type="text"
    label="Age*"
    placeholder="Young adult"
    value={formData?.age || ''}
       onChange={(e) => setFormData(prev => ({
        ...prev,
        age: e.target.value
    }))}
    sx={[
      customTextFieldStyles(false),
      {
        flex: 1,
        maxHeight: 56,
        fontSize: 14,
      },
    ]}
  /> */}
</Box>


      {/* <Box style={{ display: 'flex', gap: '16px' }}>
          <Box sx={{ minWidth: "49%", marginBottom: 3 }}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{
                      color: "rgba(255, 255, 255, 0.80)",
                      "&.Mui-focused": {
                        color: "rgba(255, 255, 255, 0.80) !important",
                      },
                    }}
                  >
                     Gender
                  </InputLabel>
                  <Select onChange={(e)=>{setFormData(prev => ({ ...prev, gender: e.target.value }))}}
                    sx={{
                      ...customTextFieldStylesforDropDownButton,
                      "& .MuiSelect-select": {
                        backgroundColor: "#282D51",
                      },
                      ".MuiSelect-icon": {
                        color: "#ffffff",
                      },
                    }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={formData.gender}
                    label="Gender"
                  >
                       <MenuItem
                      sx={{
                        bgcolor: "#2F355F",
                        marginTop: "-8px",
                        marginBottom: "-8px",
                        color: "white",
                        height: "56px",
                        "&:hover": {
                          bgcolor: "#393F69",
                        },
                        "&.Mui-selected": {
                          bgcolor: "#393F69 !important", // Ensure selected background color stays
                        },
                      }}
                      value={"Unspecified"}
                    >
                      Unspecified
                    </MenuItem>
                    <MenuItem
                      sx={{
                        bgcolor: "#2F355F",
                        marginTop: "-8px",
                        marginBottom: "-8px",
                        color: "white",
                        height: "56px",
                        "&:hover": {
                          bgcolor: "#393F69",
                        },
                        "&.Mui-selected": {
                          bgcolor: "#393F69 !important", // Ensure selected background color stays
                        },
                      }}
                      value={"Male"}
                    >
                      Male
                    </MenuItem>
                    <MenuItem
                      sx={{
                        bgcolor: "#2F355F",
                        marginTop: "-8px",
                        marginBottom: "-8px",
                        color: "white",
                        height: "56px",
                        "&:hover": {
                          bgcolor: "#393F69",
                        },
                        "&.Mui-selected": {
                          bgcolor: "#282D51 !important", // Ensure selected background color stays
                        },
                      }}
                      value={"Female"}
                    >
                      Female
                    </MenuItem>
                    <MenuItem
                      sx={{
                        bgcolor: "#2F355F",
                        marginTop: "-8px",
                        marginBottom: "-8px",
                        color: "white",
                        height: "56px",
                        "&:hover": {
                          bgcolor: "#393F69",
                        },
                        "&.Mui-selected": {
                          bgcolor: "#393F69 !important", // Ensure selected background color stays
                        },
                      }}
                      value={"Other"}
                    >
                      Other
                    </MenuItem>
                  </Select>
                </FormControl>
          </Box>

             <Box sx={{ minWidth: "49%", marginBottom: 3 }}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    sx={{
                      color: "rgba(255, 255, 255, 0.80)",
                      "&.Mui-focused": {
                        color: "rgba(255, 255, 255, 0.80) !important",
                      },
                    }}
                  >
                     Ethnicity
                  </InputLabel>
                  <Select onChange={(e)=>{setFormData(prev => ({ ...prev, ethnicity: e.target.value }))}}
                    sx={{
                      ...customTextFieldStylesforDropDownButton,
                      "& .MuiSelect-select": {
                        backgroundColor: "#282D51",
                      },
                      ".MuiSelect-icon": {
                        color: "#ffffff",
                      },
                    }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={formData.ethnicity}
                    label="Gender"
                  >
                    <MenuItem
                      sx={{
                        bgcolor: "#2F355F",
                        marginTop: "-8px",
                        marginBottom: "-8px",
                        color: "white",
                        height: "56px",
                        "&:hover": {
                          bgcolor: "#393F69",
                        },
                        "&.Mui-selected": {
                          bgcolor: "#393F69 !important", // Ensure selected background color stays
                        },
                      }}
                      value={"Unspecified"}
                    >
                      Unspecified
                    </MenuItem>
                    <MenuItem
                      sx={{
                        bgcolor: "#2F355F",
                        marginTop: "-8px",
                        marginBottom: "-8px",
                        color: "white",
                        height: "56px",
                        "&:hover": {
                          bgcolor: "#393F69",
                        },
                        "&.Mui-selected": {
                          bgcolor: "#282D51 !important", // Ensure selected background color stays
                        },
                      }}
                      value={"Caucasian"}
                    >
                      Caucasian
                    </MenuItem>
                    <MenuItem
                      sx={{
                        bgcolor: "#2F355F",
                        marginTop: "-8px",
                        marginBottom: "-8px",
                        color: "white",
                        height: "56px",
                        "&:hover": {
                          bgcolor: "#393F69",
                        },
                        "&.Mui-selected": {
                          bgcolor: "#393F69 !important", // Ensure selected background color stays
                        },
                      }}
                      value={"African"}
                    >
                      African
                    </MenuItem>
                     <MenuItem
                      sx={{
                        bgcolor: "#2F355F",
                        marginTop: "-8px",
                        marginBottom: "-8px",
                        color: "white",
                        height: "56px",
                        "&:hover": {
                          bgcolor: "#393F69",
                        },
                        "&.Mui-selected": {
                          bgcolor: "#393F69 !important", // Ensure selected background color stays
                        },
                      }}
                      value={"Asian"}
                    >
                      Asian
                    </MenuItem>
                     <MenuItem
                      sx={{
                        bgcolor: "#2F355F",
                        marginTop: "-8px",
                        marginBottom: "-8px",
                        color: "white",
                        height: "56px",
                        "&:hover": {
                          bgcolor: "#393F69",
                        },
                        "&.Mui-selected": {
                          bgcolor: "#393F69 !important", // Ensure selected background color stays
                        },
                      }}
                      value={"Hispanic"}
                    >
                      Hispanic
                    </MenuItem>
                  </Select>
                </FormControl>
          </Box>
      </Box> */}

      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
        <Checkbox
          type="checkbox"
          name="termsAccepted"
          checked={formData.termsAccepted}
          onChange={handleInputChange}
          style={{
            display: 'flex',
            width: '20px',
            height: '20px',
            justifyContent: 'center',
            alignItems: 'center',
            flexShrink: '0'
          }}
          sx={{ color: "#CAC4D0",  '&.Mui-checked': { color: "#CAC4D0", }, }}
        />
        <div style={{
          color: 'rgba(255, 255, 255, 0.80)',
          fontFamily: 'Inter',
          fontSize: '12px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: 'normal',
          letterSpacing: '0.1px'
        }}>
          By creating an avatar, I confirm that I am over 18 years of age (or the legal age in my country) and that the photos used belong to me or I have obtained explicit permission from the individual represented. I understand that I am solely responsible for the content I upload and that the use of these images must comply with all applicable laws and regulations. Additionally, I agree not to upload any photos that infringe on others' rights or that I do not have permission to use. By proceeding, I accept the Terms of Service and Privacy Policy.
        </div>
      </div>
    </div>
  );

  const renderCompleteStep = () => (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center',
      justifyContent: 'center',
      gap: '24px',
      height: 'auto',
      padding: '40px 20px'
    }}>
      <div style={{
        color: '#FFF',
        textAlign: 'center',
        fontFamily: 'Inter',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: '600',
        lineHeight: '20px'
      }}>
        Your avatar is ready!
      </div>
      <div style={{
        color: 'rgba(255, 255, 255, 0.80)',
        textAlign: 'center',
        fontFamily: 'Inter',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: 'normal'
      }}>
        You can now select this avatar for generating videos
      </div>

      {selectedAvatar !== null && (
        <div style={{
          width: '166.486px',
          height: '220px',
          flexShrink: '0',
          aspectRatio: '166.49/220.00',
          borderRadius: '16px',
          background: `url(${URL.createObjectURL(selectedFiles[selectedAvatar])}) center/cover no-repeat`
        }} />
      )}

      <button
        onClick={handleDoneButtonClick}
        style={{
          display: 'flex',
          width: '238px',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '8px',
          background: '#F6BE6B',
          padding: '12px 24px',
          border: 'none',
          color: '#17182C',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: '500'
        }}
      >
        Done
      </button>
    </div>
  );

  

  return (
    <div style={{
      maxWidth: '750px',
      height: 'auto',
      maxHeight:"90%",
      flexShrink: 0,
      borderRadius: '16px',
      border: '1px solid rgba(255, 255, 255, 0.10)',
      background: '#1F233E',
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Modal Header - Static (title hidden in complete step) */}
      <div style={{
        display: 'flex',
        width: '100%',
        padding: '20px',
        justifyContent: currentStep === 'complete' ? 'flex-end' : 'space-between',
        alignItems: 'center',
        borderBottom: currentStep === 'complete' ? 'none' : '1px solid rgba(255, 255, 255, 0.10)',
        flexShrink: 0
      }}>
        {currentStep !== 'complete' && (
          <div style={{
            color: '#FFF',
            textAlign: 'center',
            fontFamily: 'Inter',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '20px'
          }}>
            Create Custom Avatar
          </div>
        )}
        <button 
          onClick={onClose}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            fontSize: '20px'
          }}
        >
          <FaTimes />
        </button>
      </div>

      {/* Scrollable Content Area */}
      <div style={{
        padding: currentStep === 'complete' ? '0' : '20px',
        overflowY: 'auto',
        flex: 1
      }}>
        {currentStep === 'upload' && renderUploadStep()}
        {currentStep === 'review' && renderReviewStep()}
        {currentStep === 'details' && renderDetailsStep()}
        {currentStep === 'complete' && renderCompleteStep()}
      </div>

      {/* Static Footer (hidden in complete step) */}
      {currentStep !== 'complete' && (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'flex-end', 
          gap: '16px', 
          padding: '20px',
          borderTop: '1px solid rgba(255, 255, 255, 0.10)',
          flexShrink: 0
        }}>
          {currentStep === 'upload' && (
            <>
              <button
                onClick={onClose}
                style={{
                  padding: '12px 24px',
                  borderRadius: '8px',
                  background: 'transparent',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  color: 'white',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
              >
                Close
              </button>
              <button
                onClick={handleProceed}
                disabled={selectedFiles.length === 0 || uploadImageLoader}
                style={{
                  padding: '12px 24px',
                  borderRadius: '8px',
                  background: selectedFiles.length > 0 ? button_bg_color_for_New_Project : 'rgba(230, 224, 233, 0.12)',
                  border: 'none',
                  color: selectedFiles.length > 0 ? '#17182C' : "#E6E0E9",
                  opacity: selectedFiles.length > 0 ? 1 : 0.38,
                  cursor: selectedFiles.length > 0 ? 'pointer' : 'not-allowed',
                  fontSize: '14px',
                  fontWeight: '500',                  
                }}
              >
                {
                  uploadImageLoader ? <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                /> : "Upload"
                }
              </button>
            </>
          )}
          {currentStep === 'review' && (
            <>
              <button
                onClick={() => setCurrentStep('upload')}
                style={{
                  padding: '12px 24px',
                  borderRadius: '8px',
                  background: 'transparent',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  color: 'white',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
              >
                Go back
              </button>
              <button
                onClick={handleProceed}
                disabled={selectedAvatar === null}
                style={{
                  padding: '12px 24px',
                  borderRadius: '8px',
                  background: selectedAvatar !== null ? button_bg_color_for_New_Project : 'rgba(230, 224, 233, 0.12)',
                  border: 'none',
                  color: selectedAvatar !== null ? "#17182C"  :  '#E6E0E9',
                  opacity: selectedAvatar !== null ? 1 : 0.38,
                  cursor: selectedAvatar !== null ? 'pointer' : 'not-allowed',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
              >
                Proceed
              </button>
            </>
          )}
          {currentStep === 'details' && (
            <>
              <button
                onClick={() => setCurrentStep('review')}
                style={{
                  padding: '12px 24px',
                  borderRadius: '8px',
                  background: 'transparent',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  color: 'white',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500'
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleProceed}
                disabled={!formData.termsAccepted}
                style={{
                  padding: '12px 24px',
                  borderRadius: '8px',
                  background: formData.termsAccepted ? button_bg_color_for_New_Project : 'rgba(230, 224, 233, 0.12)',
                  border: 'none',
                  color:  formData.termsAccepted ?  '#17182C' : "#E6E0E9",
                  cursor: formData.termsAccepted ? 'pointer' : 'not-allowed',
                  opacity: formData.termsAccepted ? 1 : 0.38,
                  fontSize: '14px',
                  fontWeight: '500'
                }}
              >
                {
                  avatarCreationLoader ?  <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                /> : "Continue"
                }
              </button>
            </>
          )}
        </div>
      )}
      <CommonToast  open={openToast} onClose={onCloseToast} content={content} iconType={iconType} bgColor={"#282D51"}/>
    </div>
  );
};

export default CustomAvatar;